import React, {useEffect} from "react";
import ReactGA from "react-ga";
import Header from "./Header";
import {createConditionalRequire, createValueGroupRequired} from "../utils";

const kadriPictures = [
    /*
    require("./profile_pictures/kadri/kadri_mannimets1.jpg"),
    require("./profile_pictures/kadri/kadri_mannimets2.jpg"),
    require("./profile_pictures/kadri/kadri_mannimets3.jpg"),
    require("./profile_pictures/kadri/kadri_mannimets4.jpg"),
    require("./profile_pictures/kadri/kadri_mannimets5.jpg"),
    require("./profile_pictures/kadri/kadri_mannimets6.jpg"),
    */
];
//const kadriPicture = kadriPictures[Math.floor(Math.random() * kadriPictures.length)]

const teachersAssistants = [
    /*
        {
            name: "Anastassia Voronina",
            languages: ['🇷🇺'],
            picture: require("./profile_pictures/anastassia_voronina.jpg")
        },
        {
            name: "Anton Matskevitš",
            languages: ['🇷🇺'],
            picture: require("./profile_pictures/anton_matskevits.png")
        },
        {
            name: "Diana Christine Tarro",
            picture: require("./profile_pictures/diana_christine_tarro.jpg")
        },
        {
            name: "Edvin Mihhailov",
            picture: require("./profile_pictures/edvin_mihhailov.jpg")
        },
        {
            name: "Henri Keerutaja",
            picture: require("./profile_pictures/henri_keerutaja.jpg")
        },
        {
            name: "Kadri Männimets",
            picture: kadriPicture
        },
        {
            name: "Kaisa-Mari Veinberg",
            picture: require("./profile_pictures/kaisa-mari_veinberg.jpg")
        },
        {
            name: "Kalev Kilumets",
            picture: require("./profile_pictures/cat.jpg")
        },

        {
            name: "Karl Raud",
            picture: require("./profile_pictures/karl_raud.jpg")
        },
        {
            name: "Kaspar Ustav",
            picture: require("./profile_pictures/kaspar_ustav.JPG")
        },
        {
            name: "Kristjan Kõiv",
            picture: require("./profile_pictures/kristjan_k6iv.jpg")
        },
        {
            name: "Lauri Simulman",
            picture: require("./profile_pictures/lauri_simulman.jpg")
        },
        {
            name: "Marcus Pruks",
            picture: require("./profile_pictures/marcus_pruks.jpg")
        },
        {
            name: "Maria Gazieva",
            languages: ['🇷🇺'],
            picture: require("./profile_pictures/cat.jpg")
        },
        {
            name: "Maria Kaasik-Aaslav",
            picture: require("./profile_pictures/maria_kaasik-aaslav.jpg")
        },
        {
            name: "Mihkel Oper",
            picture: require("./profile_pictures/mihkel_oper.png")
        },
        {
            name: "Nele Sergejeva",
            picture: require("./profile_pictures/nele_sergejeva.jpg")
        },
        {
            name: "Peeter Maran",
            picture: require("./profile_pictures/peeter_maran.jpg")
        },
        {
            name: "Rasmus Maipuu",
            picture: require("./profile_pictures/rasmus_maipuu.jpg")
        },
        {
            name: "Siim Martin Saarts",
            picture: require("./profile_pictures/siim_martin_saarts.jpg")
        }

        */
    ]
;
const agoPicture = require("./profile_pictures/ago_luberg.jpg");
const ahtiPicture = require("./profile_pictures/ahti_lohk.jpg");


const Info = () => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/info");
    }, []);
    return (<>
        <Header title="Programmeerimise algkursuse info"/>

        <section className="section">
        <div className="container">
                <h1 className="title">
                    Tere, hea tudeng!
                </h1>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/HXfmANk_16Y?showinfo=0" frameborder="0"
                            allowfullscreen></iframe>
                </figure>
                <p className="text">
                    Programmeerimise algkursusel (ITI0102) saad selgeks, mis on programmeerimine ja kuidas kirjutada
                    programmeerimiskeeles Python erinevaid programme.
                </p>
                <p className="text">
                    Ole hea, aita meid sellega, et võtad 20-25 minutit aega ja mõtled meiega kaasa.
                    Järgnevatel slaididel on olulist infot aine kohta ning mõned küsimused, mille vastused on meile
                    huvitavad ja olulised aine ettevalmistamisel.
                </p>
                <p className="text">
                    Kui saad, ole hea, kasuta oma tegelikku ees- ja perekonnanime ja vasta julgelt ja otsekoheselt -
                    siis saan selge pildi Su vajadustest ja tean aidata, kui seda peaks vaja minema. Siin pole ükski
                    vastus vale!<br/>
                </p>
                <p className="text">
                    <strong>NB! Su vastuseid nimega seotuna näen vaid mina, vastutav õppejõud Ago Luberg.</strong><br/>
                    Üldistatud andmeid jagan ka aine abiõppejõududega, et ka nemad saaksid teid kõiki paremini toetada.
                </p>
                <p className="text">
                    <strong>Ago Luberg</strong><br/>
                    Aine eest vastutav õppejõud ja informaatika õppekava programmijuht
                </p>
            </div>
        </section>
        <section className="section">
        <div className="container">
                    <figure className="image video-container">
                        <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/W1nAnNK8QXk?showinfo=0" frameborder="0"
                            allowfullscreen></iframe>
                    </figure>
                    <p className="text">
                        Selles aines saad Sa suure pildi sellest, mis on tänapäevane programmeerimine, miks seda vaja on ja kuidas programmeerijad päriselt töötavad.
                    </p>
                    <p className="text">
                        Kursuse lõpuks <strong>oskad Pythoni keeles viia ellu oma pöörased ja vähem pöörased ideed. </strong>
                        Python on väga hea keel programmeerimise õppimiseks,
                        see on selgelt kõige olulisem keel masinõppe maailmas ja #1 keel kasutussageduselt programmeerijate hulgas: <a href="https://madnight.github.io/githut/" target="_blank">GitHut</a> ja <a href="https://www.tiobe.com/tiobe-index/" target="_blank">Tiobe</a> järgi.
                    </p>
                    <p className="text">
                        Kui soovid varem või hiljem tegeleda suuremate projektidega, on Sulle kasu ka <strong>Git versioonihaldustarkvarast, mida kursusel kasutama õpime</strong> - Git on standard pea igas tiimis ja kogukonnas. 
                        Giti abiga salvestub Su kood pilve, tänu millele saavad teised arendajad seda vaadata ja vajadusel täiendada. 
                    </p>
                    <p className="text">
                        Kursuse käigus teeme palju väikseid ülesandeid, millel igal on oma <strong>tähtaeg</strong>. 
                        Kui pingutad veidi ja harjud ära koodi kirjutamisega õigeks tähtajaks, on Sul juba üks <strong>hinnatud oskus</strong> juures. 
                        Rääkimata sellest, et ka endal on mugavam, kui oled ajakavas. 
                    </p>
                    <p className="text">
                        Kui Sa siin koostöös meiega pingutad ja aine edukalt läbid, teevad õpitud teadmised ja oskused järgmistes ainetes õppimise palju lihtsamaks ja põnevamaks!
                    </p>
                    <p className="text">
                        Siin ma proovin veel asjad lühidalt kokku võtta:
                    </p>
                    <figure className="image video-container">
                        <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/WL8CzJe-7_8?showinfo=0" frameborder="0"
                            allowfullscreen></iframe>
                    </figure>
                </div>
        </section>
        <section className="section">
        <div className="container">
                <p className="text">
                    Meie aines osaleb sel aastal üle 500 tudengi. Selleks, et igaüks saaks vajadusel abi, on meil suur
                    tiim! Allpool tutvustame Sulle ennast ja siis küsime Sinu kohta ühe olulise küsimuse!
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Õppejõudude tiim
                </h1>
            </div>
            <div className="container">
                <img className="profile-picture" src={agoPicture}/>
                <p className="text">
                    Mina olen <strong>Ago Luberg</strong>, vastutan päevaõppe eest. Näed mind kõikidel loengutel ja võid
                    minu poole igal ajal pöörduda – koputa õlale, kirjuta e-kiri ago.luberg@taltech.ee või saada
                    privaatne sõnum Discordis (vt allpool). Et ma ei jääks vaid avatariks, tegin väikese video!
                </p>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/p21LfA2Ux74?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
            </div>
            <div className="container">
                <img className="profile-picture" src={ahtiPicture}/>
                <p className="text">
                    Mina olen <strong>Ahti Lohk</strong> ja vastutan sessioonõppe eest. Minuga saab ühendust:
                    ahti.lohk@taltech.ee .
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Abiõppejõud:
                </h1>
                <div className="text">
                    Meie tiimis on ka mitu abiõppejõudu, kes kõik on selle kursuse edukalt läbinud tudengid.
                    Abiõppejõude näed Sa seminarides ja ülesannete kaitsmisel - nad aitavad Sind hea meelega!
                    Meil on kogemus, et igaüks, kes on natuke pingutanud ja vajadusel abi küsinud, on kursuse edukalt ka
                    läbinud!
                </div>
                <div className="profiles">
                    {
                        teachersAssistants.map(assistant => (<div className="profile">
                            <img className="profile-picture" src={assistant.picture}/>
                            <h2 className="profile-name">
                                {assistant.name} <span>🇪🇪</span> <span>🇬🇧</span>
                                {assistant.languages ? assistant.languages.map(lang => (
                                    <span>{lang}</span>
                                )) : null}
                            </h2>
                        </div>))
                    }
                </div>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Discord omavahel suhtlemiseks
                </h1>
                <p className="text">
                    Lisaks loengutele, mida saab vaadata ka videotena, ja seminaridele, kus näeme üksteist kord
                    nädalas, saavad kõik omavahel suhelda ka virtuaalselt, kasutades selleks
                    suhtlemisrakendust <strong>Discord</strong>. <a href="https://discord.gg/3pg2sNUStB"
                                                                    target="_blank">Vajuta
                    siia</a>, et luua endale kasutaja ja liituda aine grupiga.
                </p>
            </div>
        </section>
        <section className="section">
        <div className="container">
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/CQg-sTQ4giA?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
            </div>
            <div className="container">
                <p className="text">
                    Aine on loodud nii, et saad sellega hästi hakkama ilma varasema programmeerimise kogemuseta.
                    Mõndagi uut ja huvitavat leiad aga aines ka siis, kui oled programmeerimisega juba tegelenud.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Mida kasulikku me siis ikkagi õpime?
                </h1>
                <p className="text">
                    Kursuse lõpuks oled oluliselt rohkem kodus kuues programmeerimise võtmeteemas:
                </p>
                <ol className="list">
                    <li>
                        Mis on põhilised programmeerimise käsud – ehitusplokid ja tööriistad, mida mistahes keeles
                        kasutab iga programmeerija.
                    </li>
                    <li>
                        Kuidas neid olulisemaid käske kirjutada Pythoni keeles.
                    </li>
                    <li>
                        Rekursioon – elegantne viis lahendada ülesandeid nii, et kasutad ühe funktsiooni (programmi
                        väike tükike, mis lahendab kindlat ülesannet) töö lihtsustamiseks sedasama funktsiooni.
                    </li>
                    <li>
                        Kuidas toimib objektorienteeritud programmeerimine. Objekt on tükk programmist, millel on sees
                        funktsioon, omad andmed ja ülesanded.
                    </li>
                    <li>
                        Kuidas programmid saavad kasutada ja toimetada faile.
                    </li>
                    <li>
                        Kuidas programmid saavad lugeda infot veebist (API).
                    </li>
                </ol>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Kuidas see kõik selgeks saada? Töötame veidike iga nädal!
                </h1>
                <p className="text">
                    Programmeerimine on ennekõike praktiline oskus.
                    Selleks, et tulevikus oleks lihtne kodeerida, lahendame igal nädalal ülesandeid, mis lähevad järjest
                    keerulisemaks ja põnevamaks.
                </p>
                <p className="text">
                    Oleme kogenud seda, et tudengid, kes teevad ülesandeid iga nädal, saavad mõistliku pingutusega hästi
                    hakkama.
                    Kui aga vahepeal lasta pikem paus sisse, võib minna oluliselt keerulisemaks.
                    Kui nii peaks ikkagi juhtuma, pea meeles, et oleme toeks ja pingutame koos Sinuga, et saada järjele
                    tagasi.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Mis selles kõiges siis keerulist on?
                </h1>
                <p className="text">
                    Programmeerimises on vaja mõelda abstraktselt – teatud mõttes tuleb enne koodiridade kirja panemist
                    programm, või selle osad, tervikuna valmis mõelda.
                </p>
                <p className="text">
                    Koolis puutusid kokku matemaatikaülesannetega, mida tuli lihtsalt lahendada.
                    Selles aines läheme sammu edasi – kirjeldame ära, kuidas arvuti peaks lahendama
                    matemaatikaülesannet.
                    Näiteks tekstiülesande lahendamise asemel kirjeldame arvutile üldistatud juhendi, kuidas sellist
                    tüüpi ülesannet peaks lahendama.
                </p>
                <p className="text">
                    See on tegelikult väga põnev!
                    Aga ole valmis ka selleks, et mõnikord on see ka harjumatu ja raske - võib tekkida tunne, et ei saa
                    kohe hakkama.
                    See tunne on OK, kuid pane end selleks valmis ja küsi julgelt abi!
                </p>
            </div>
            <div className="container">
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/O-MMknEB7ZI?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
                <p className="text">
                    Lisaks algkursusele toimub sügisel Programmeerimise täiendusõpe, mis kestab 1. – 5. õppenädalal.
                    Selles aines anname täiendavaid ülesandeid, et saaksid oma programmeerimisoskust arendada.
                    Räägin sellest täpsemalt esimeses loengus.
                </p>
            </div>
        </section>
        <section className="section">
            <div className="container">
                <p className="text">
                    Algkursust võtab päris suur hulk tudengeid, kellest mõnel on juba kogemus programmeerimise ja IT-ga,
                    aga paljudel ei ole.
                </p>
                <p className="text">
                    Oleme arvestanud teie kõigiga - meil on päris mitu toetavat süsteemi, kui oled päris algaja, aga
                    pakume väljakutseid ka neile, kes on juba programmeerimisega sina peal.
                </p>
                <p className="text">
                    Videos räägib abiõppejõud Nele Sergejeva sellest, mida pakume erineva IT-kogemusega tudengitele ja
                    pärast küsime Sult, millise kogemusega gruppi Sa ennast kuuluvaks pead.
                </p>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/aN63zyI64Ow?showinfo=0" frameBorder="0"
                            allowFullScreen></iframe>
                </figure>
                <p className="text">
                    Kui nüüd tunned, et Sul oleks abi täiendusõppe ainest, hoia silma peal aine Discordi serveril, kus
                    peagi selle kohta infot jagame!
                </p>
            </div>
        </section>
        <section className="section">
        <div className="container">
                <p className="text">
                    Siin saad ülevaate sellest, millised on olulised sündmused semestri jooksul ja kuidas kujuneb hinne. 
                    Detailsemat infot saad varsti lugeda Moodle'i keskkonnast ja ka esimesel loengul!
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Iganädalased ülesanded
                </h1>
                <p className="text">
                    Selles aines ootame Sinult, et Sa lahendad iga nädal iseseisvalt ülesandeid.
                    Ülesanded lähevad iga kord veidi keerulisemaks, seepärast ei tasu nädalat vahele jätta - nii on Sul palju mõnusam ja efektiivsem õppida.
                </p>
                <p className="text">
                    Praktiliselt soovitame:
                </p>
                <ul className="list">
                    <li>
                        alustada ülesannetega võimalikult varakult
                    </li>
                    <li>
                        esitada ülesanded tähtajaks, sest tähtaja ületades saab vähem punkte
                    </li>
                    <li>
                        ülesande kohta saame anda Sulle personaalset tagasisidet Sinu koostatud programmikoodi kohta.
                    </li>
                </ul>
                <p className="text">
                    Iganädalased ülesanded annavad kokku maksimaalselt 50% hindest.
                </p>
                <p className="text">
                    NB! 1. – 5. nädalal toimub paralleelselt meie ainega ka Programmeerimise täiendusõpe, mis on soovituslik.
                    Selles aines anname täiendavaid ülesandeid ja juhtnööre, et saaksid oma programmeerimisoskuse paremale tasemele viia.
                    Täiendusõpe ei ole kohustuslik, aga väga soovituslik!
                </p>
            </div>

            <div className="container">
                <h1 className="subtitle">
                    Iganädalased praktikumide ja loengute ajad
                </h1>
                <p className="text">
                    Loengud toimuvad paaritul nädalal teisipäeviti kell 12:00 ruumis U06A-229. Alates kolmandast nädalast toimuvad loengud ICT-121, ICT-122 klassides.
                    Loengud salvestatakse ja on järelvaadatavad YouTube'is.
                </p>
                <p className="text">
                    Lisaks loengutele toimuvad praktilised tunnid arvutiklassis, kus oleme kohal mitme õppejõuga, et saaks abi küsida.<br />
                    Kõik praktikumid toimuvad ruumides ICT-121, ICT-122.<br />
                    Praktikumide ajad nädala sees:
                    <ul className="list">
                        <li>Teisipäeval 14:00</li>
                        <li>Kolmapäeval 14:00</li>
                        <li>Neljapäeval 10:00</li>
                    </ul>
                    <br/>
                    Sessioonõppel toimuvad tunnid (loeng + praktikum) laupäeviti:
                    <ul className="list">
                        <li>9. septembril kell 14:45 - 16:30</li>
                        <li>23. septembril kell 13:30 - 15:15</li>
                        <li>7. oktoobril kell 13:30 - 15:15</li>
                        <li>21. oktoobril kell 13:30 - 15:15</li>
                        <li>4. novembril kell 15:15 - 17:00</li>
                        <li>18. novembril kell 15:15 - 17:00</li>
                        <li>2. detsembril kell 15:15 - 17:00</li>
                        <li>16. detsembril kell 15:15 - 17:00</li>
                    </ul>
                    <br />
                    Kõik vajalik info sessioonõppele räägitakse ära tavapärastes loengutes (teisipäeviti), mida saab YouTube'i kaudu järelvaadata.<br />
                    <br />
                    Täiendusõppe tunnid toimuvad järgmistel aegadel:
                    <ul className="list">
                        <li>Teisipäeval 16:00 - 19:15 (toimub 1. - 5. nädal)</li>
                        <li>Reedel 10:00 - 11:30 (toimub nädalatel 1, 2, 3, 5, 6)</li>
                        <li>Reedel 15:45 - 17:15 (toimub nädalatel 1, 2, 3, 5, 6)</li>
                    </ul>
                </p>
                <p className="text">
                    Tundide ajad on kättesaadavad tunniplaanis. Igaks juhuks tasub seda jooksvalt jälgida, kui mõni aeg peaks muutuma.
                    <strong>Võib külastada ükskõik millist praktikumi.</strong> Ka ühel nädalal võib mitmes käia. Midagi ei juhtu, kui praktikumi ei jõua.
                    Praktikumi eesmärk on anda võimaluse abiõppejõult küsida ja saada vahetut abi.
                </p>
                <p className="text">
                    Loengut ja praktikume on võimalik järele vaadata ka videona. Praktikumis tavaliselt mingit esitust/ettekannet ei toimu. 
                    Kui aga toimub, siis saab seda videona järele vaadata. Pigem on praktikumides abiõppejõud, 
                    kellele saab ülesandeid ette näidata ja kellelt saab oma koodi ja murede kohta personaalset abi.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Tunnikontroll, kontrolltöö ja eksam
                </h1>
                <ul className="list">
                    <li>
                        Tunnikontroll toimub 5. nädalal (2. oktoober - 8. oktoober). 
                        Siin anname lahendamiseks väiksemad ja lihtsamad ülesanded selleks, et saada tagasisidet teie taseme kohta. 
                        <strong> Tunnikontrolli läbimine on vajalik, et saada eksamile. </strong>
                    </li>
                    <li>
                        Kontrolltöö toimub umbes 10. nädalal.
                        Siin anname lahendamiseks juba natuke mahukamad ülesanded. 
                        <strong> Kontrolltöö läbimine on vajalik, et saada eksamile.</strong>
                    </li>
                </ul>
                <p className="text">
                    Aine lõppeb eksamiga, mis toimub füüsiliselt ülikooli ruumides jaanuaris. 
                    Eksamil tuleb kooliarvutisse kirjutada toimiv programmikood ning vastata küsimustikule. 
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Süvendatud Pythoni lisakursus/ülesanded
                </h1>
                <p className="text">
                    Osade tudengite jaoks on tavalise algkursuse tempo aeglane ning nad tahaksid ennast proovile panna veel põnevamate ülesannetega.
                    Selleks oleme kursusele lisanud eraldi osa: süvendatud Pythoni alamkursus (me ise ütleme: süva-Python).
                    Sellest võivad osa võtta kõik - me isegi soovitame seda proovida kõikidel.
                    Süvendatud alamosa tähendab seda, et semestri jooksul pakume lahendamiseks mahukamaid ja põnevamaid ülesandeid.
                    Nende lahendamine on vabatahtlik.
                </p>
                <p className="text">
                    <strong>Süvendatud Pythoni ülesannete eest saab umbes 10% hindest. </strong>
                    See suuresti tähendab seda, et hinde "5" saamiseks on väga soovituslik mõni selline ülesanne lahendada.
                </p>
                <p className="text">
                    Paaris nädala teisipäeviti toimub süvendatud Pythoni praktikum, kus arutleme süva-Pythoni ülesannete üle ning saab vastavaid ülesandeid ette näidata.
                </p>
            </div>
            <div className="container">
            <h1 className="subtitle">
                    Kuidas tuleb kokku lõpphinne?
                </h1>
                <p className="text">
                    <strong>Kokku on kõigi tegevuste eest võimalik saada üle 1000 punkti. </strong>
                    See jaotub nii:
                </p>
                <ul className="list">
                    <li>
                        480 punkti saad Sa õigeaegselt tehtud ülesannete eest (iga nädal 32 punkti x 15 nädalat);
                    </li>
                    <li>
                        20 punkti saad kontrolltöö eest (10. nädalal);
                    </li>
                    <li>
                        100 ja rohkemgi punkti saad Sa boonusülesannete eest;
                    </li>
                    <li>
                        400 punkti on võimalik saada eksami eest;
                    </li>
                    <li>
                        Lisaks saab erinevate täiendavate tegevuste eest lisapunkte (lõplik maksimumsumma on isegi üle 1000 punkti).
                    </li>
                </ul>
                <p className="text">
                    Hinne kujuneb vastavalt punktidele nii:
                    <ul className="list">
                        <li>
                            901+ punkti → hinne "5"
                        </li>
                        <li>
                            801+ punkti → hinne "4"
                        </li>
                        <li>
                            701+ punkti → hinne "3"
                        </li>
                        <li>
                            601+ punkti → hinne "2"
                        </li>
                        <li>
                            501+ punkti → hinne "1"
                        </li>
                        <li>
                            500 punkti või vähem → hinne "0"
                        </li>
                    </ul>
                </p>
            </div>
        </section>
        <section className="section">
            <div className="container">
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/89jnt4QsMQM?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
            </div>
            <div className="container">
                <p className="text">
                    Ülikoolis, nagu ka muus elus, on kõige parem teha koostööd siis, kui rääkida avatud tekstiga ootused läbi ja katsuda leppida milleski kokku.
                    Teen Sulle ettepaneku leppida kokku järgnevas:
                </p>
            </div>

            <div className="container">
                <h1 className="subtitle">
                    Meie lubame, et:
                </h1>
                <ul className="list">
                    <li>
                        Teeme Su jaoks nii põneva kursuse, kui oskame.
                        Oleme tiimiga pingutanud terve suve, et valmistuda ja võtta arvesse eelmise aasta tagasisidet!
                    </li>
                    <li>
                        Tuleme Sulle ülesannete lahendamisel ja õppimisel appi!
                        Oleme kättesaadavad praktikumide ajal (kui ka tekib järjekord, siis jõuame Sinuni, isegi kui selleks kulub natuke aega).
                    </li>
                    <li>
                        Sa saad oma ülesannet kaitsta välja lubatud päeval.
                    </li>
                    <li>
                        Vastame Su esitatud küsimustele, näiteks Discordis.
                    </li>
                    <li>
                        Küsime regulaarselt tagasisidet ja arvestame sellega!
                    </li>
                    <li>
                        Suur osa kursusest on loodud nii, et seda saab läbida ka virtuaalselt.
                    </li>
                    <li>
                        Kui jääd päriselt hätta ja tundub, et olukord on lootusetu – ka siis kuulame Su ära ja leiame lahenduse!
                    </li>
                </ul>
            </div>

            <div className="container">
                <h1 className="subtitle">
                    Me ootame Sinult, et:
                </h1>
                <ul className="list">
                    <li>
                        Kui läheb raskeks, küsid julgelt abi. Sõnasta oma mure kohe, kui jääd hätta, et me kindlasti jõuaksime Sind aidata. Me oleme kõik tudengid, või oleme need olnud, ja ühel või teisel hetkel hädas olnud.
                    </li>
                    <li>
                        Teed ülesandeid iseseisvalt ja ei karda teha vigu. Vigadest saad Sa õppida, aga plagiaat on tõsine eksimus ülikooli kõige olulisemate reeglite vastu ja ei aita Sind kuidagi edasi.
                    </li>
                    <li>
                        Pingutad, et esitada kodutööd õigeaegselt ja alustad ülesannete tegemist varakult.
                        Nii on väiksem risk, et ülesanded kuhjuvad semestri lõppu ja põneva pingutuse ja õppimise asemel saab sellest Sulle probleem.
                    </li>
                    <li>
                        Annad meile regulaarset tagasisidet kursuse kohta, et teaksime, mis seisus Sina ja teised tudengid on ja vajadusel muudaksime programmi.
                    </li>
                </ul>
            </div>
        </section>
        <section className="section">
            <div className="container">
                <p className="text">
                    Kui Sul on huvi programmeerimisega rohkem tutvust teha, siis:
                    <ul>
                        <li><a href="https://pydoc.pages.taltech.ee/" target="_blank">https://pydoc.pages.taltech.ee/</a> - siit leiad õppematerjalid;</li>
                        <li><a href="https://moodle.taltech.ee/course/view.php?id=32806" target="_blank">Täienduskursus Moodle keskkonas</a> - siit
                            leiad harjutamiskeskkonna.
                        </li>
                    </ul>
                </p>
                <p className="text">
                    Kui peaks veel vaja minema, siis <a href="https://discord.gg/3pg2sNUStB" target="_blank">Discordi link on siin</a>.
                </p>
            </div>
        </section>



    </>);
};

export default Info;
